import React from "react";
import "./Loading.scss";

const Loading: React.FunctionComponent<any> = ({text}) => {
  return <div className="loading-indicator">{text || "Loading..."}</div>
};

export default Loading;
